import { Component, Input } from "@angular/core";

export interface RecetarioStatus {
  habilitado: boolean;
  activeInApi: boolean;
  datosFaltantes: string[];
  todosLosDatosCompletos?: boolean;
}

const LABELS: { [key: string]: string } = {
  email: "Email",
  name: "Nombre",
  surname: "Apellido",
  title: "Titulo (Dr./Dra.)",
  license_type: "Tipo de matricula",
  matricula: "Matricula",
  numeroDocumento: "Número de documento",
  province: "Provincia",
  address_street: "Calle",
  address_number: "Número de calle",
  signature: "Firma digital",
};

@Component({
  selector: "app-recetario-banner",
  templateUrl: "./recetario-banner.component.html",
  styleUrls: ["./recetario-banner.component.scss"],
})
export class RecetarioBannerComponent {
  @Input() recetarioStatus: RecetarioStatus;

  get estado():
    | "no_habilitado"
    | "faltan_datos"
    | "sincronizado"
    | "pendiente_sync" {
    if (!this.recetarioStatus?.habilitado) {
      return "no_habilitado";
    }
    if (this.recetarioStatus.datosFaltantes?.length > 0) {
      return "faltan_datos";
    }
    if (this.recetarioStatus.activeInApi) {
      return "sincronizado";
    }
    return "pendiente_sync";
  }

  getLabel(campo: string): string {
    return LABELS[campo] || campo;
  }
}
